<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';
	import TempWheelWithButtonsV2 from './TempWheelWithButtonsV2.svelte';
	import { format } from '../../../../../../../../../services/i18n';
	import { ColorWheel, ButtonGroup, Button, FavColor } from '@Shelly/shelly-design-system';
	import { requestUserColors } from 'src/helpers/colors_helpers';
	import { list_of_color } from 'src/stores/wizards';
	import { postReq } from 'src/services/http';
	import { fade } from 'svelte/transition';

	export let type: 'no_mode' | 'change_mode' = 'no_mode',
		active_actions = [],
		range = [3000, 6500],
		predefined: 'color' | 'white' | undefined,
		disabled = false;

	let active_mode = active_actions?.find((el) => el.r)
		? 'color'
		: active_actions.find((el) => el.name === 'temp' || el.name === 'ct')
			? 'white'
			: //because somehow there are scenes with active mode -100 ???????
				active_actions.find((el) => el.name === 'mode')?.value || undefined;

	let color = {
		r: active_actions.find((el) => el.name === 'r')?.value || 200,
		g: active_actions.find((el) => el.name === 'g')?.value || 200,
		b: active_actions.find((el) => el.name === 'b')?.value || 200,
	};
	let temp = active_actions.find((el) => el.name === 'temp' || el.name === 'ct')?.value || 3000;

	let mode = active_mode || predefined || 'color';
	let favoriteColors = [];

	onMount(async () => {
		const favColorsReq = await requestUserColors();
		let userColors = favColorsReq ? favColorsReq : [];
		favoriteColors = userColors.map((colorObj) => {
			return {
				active: JSON.stringify(colorObj) === JSON.stringify(color),
				color: `rgb(${colorObj.r}, ${colorObj.g}, ${colorObj.b})`,
				colorObj,
			};
		});
		list_of_color.reset();
	});

	const dispatch = createEventDispatcher();

	const dispach_change = () => {
		dispatch('change', {
			mode,
			value: mode === 'color' ? color : temp,
		});
	};

	const handle_mode = (_mode) => {
		mode = _mode.selected;
		dispach_change();
	};

	const handle_color = (newColor) => {
		mode = 'color';
		color = newColor;

		favoriteColors = favoriteColors.map((oldColor) => {
			if (JSON.stringify(newColor) === JSON.stringify(oldColor.colorObj)) {
				return {
					...oldColor,
					active: true,
				};
			} else {
				return {
					...oldColor,
					active: false,
				};
			}
		});
		dispach_change();
	};

	const onDeleteColor = (index: number) => {
		favoriteColors = favoriteColors.filter((_, i) => i !== index);
		updateColorsList();
	};

	const updateColorsList = async () => {
		let favoriteColorsData = favoriteColors.map((fc) => {
			return {
				...fc.colorObj,
			};
		});

		const data = {
			colors: favoriteColorsData,
		};

		const res = await postReq('/interface/user_colors/save', {
			data: JSON.stringify(data),
		});

		if (res.isok) {
		} else {
			console.error('Failed to set colors');
		}
	};

	const handle_temp = (e) => {
		mode = 'white';
		temp = e.detail.value;
		dispach_change();
	};
</script>

{#if type === 'change_mode'}
	<div class="text-center mb-s">
		<ButtonGroup
			id="buttongroup-0851xn3"
			aria-label={$format('label_select_mode', { default: 'Select mode' })}
			{disabled}
		>
			{#each [{ selected: 'color', title: $format('button_color') }, { selected: 'white', title: $format('button_white') }] as _mode, _ind}
				<Button
					class={_mode.selected === mode ? 'active' : ''}
					size="m"
					on:click={() => handle_mode(_mode)}
					{disabled}
				>
					{_mode.title}
				</Button>
			{/each}
		</ButtonGroup>
	</div>
{/if}
{#if mode === 'color'}
	<div in:fade={{ duration: 300 }}>
		<ColorWheel
			id="colorwheel-87ddflq"
			class="mb-s"
			hideSaveBtn
			{color}
			on:color_change={(e) => handle_color({ ...e.detail.color })}
			{disabled}
		/>
		<div class="d-flex flex-wrap">
			{#each favoriteColors as favColor, i}
				<FavColor
					a11yProps={{
						deleteButtonAriaLabel: $format('label_delete_color', {
							default: 'Delete color',
						}),
						favColorAriaLabel: $format('label_fav_color', { default: 'Favorite color' }),
					}}
					class="mr-xs mb-xs ml-xs"
					color={favColor.color}
					on:click={() => handle_color(favColor.colorObj)}
					on:delete={() => onDeleteColor(i)}
					active={favColor.active}
				/>
			{/each}
		</div>
	</div>
{:else if mode === 'white'}
	<TempWheelWithButtonsV2 {disabled} value={temp} {range} on:change={(e) => handle_temp(e)} />
{/if}
